import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { VersionControlService } from '../../version-control/version-control.service';
import { AppState } from '../../model/reducer';
import { select, Store } from '@ngrx/store';
import _ from 'lodash';
import { allInventoriesView, selectedTenantKeyView, shouldDisplayTenantsView } from '../../model/views';
import { Inventory } from '../inventory.model';

@Injectable()
export class ImportInventoryContext {
  private versionControlService = inject(VersionControlService);
  private store$ = inject<Store<AppState>>(Store);

  inventories$: Observable<Inventory[]>;
  selectedTenantKey$: Observable<string>;
  displayTenant$: Observable<boolean>;

  constructor() {
    this.inventories$ = this.store$.pipe(select(allInventoriesView), map(_.values));
    this.selectedTenantKey$ = this.store$.pipe(select(selectedTenantKeyView)) as Observable<string>;
    this.displayTenant$ = this.store$.pipe(select(shouldDisplayTenantsView));
  }
}
